export enum EnumSistemaIntegracaoStatus {
  NaoIntegrado = 0,
  Integrado = 1,
  ErroAoIntegrar = 2,
  PrecisaSerAtualizado = 3
}
